import * as React from 'react';
import { View, TouchableOpacity, Text, Platform, Picker } from 'react-native';
import { Icon, Thumbnail, Button } from 'native-base';
import Modal from 'modal-enhanced-react-native-web';
import { render } from 'react-native-web';

export default class materialDrop extends React.PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			visible: false
		};
	}
	//console.log('nonnative');
	setVisible(vis) {
		this.setState({ visible: vis });
	}

	render() {
		const { actions, onPress, style = {}, uri, destructiveButtonIndex = -1, hideArrow = false } = this.props;
		const { visible } = this.state;
		const ICON_SIZE = 24;
		const { backgroundColor = 'transparent', borderColor = 'transparent', color = '#EEE', fontSize = 20, textPaddingTop = 7, padding = 10, ...restStyles } = style;
		return (
			<View style={{ flexDirection: 'row', ...restStyles }}>
				<TouchableOpacity
					onPress={() => {
						this.setVisible(true);
					}}
					style={{ backgroundColor: 'transparent', padding, flexDirection: 'row', alignItems:'center' }}>
					{this.props.uri && <Thumbnail small source={{ uri: this.props.uri }} />}
					<Text ref="menu" style={{ color, paddingTop: textPaddingTop, fontFamily: 'Roboto', fontSize, paddingHorizontal: 8 }}>
						{this.props.text}
					</Text>
					{!hideArrow && <Icon name="arrow-dropdown" style={{ color: '#BBB', paddingTop: 8, marginRight:8, fontSize: 20 }} />}
				</TouchableOpacity>
				<Modal
					//animationIn="slideInUp"
					//animationOut="slideOutDown"
					animationType="fade"
					backdropOpacity={0.5}
					isVisible={visible}
					transparent={true}
					onBackdropPress={() => {
						this.setVisible(false);
					}}
					presentationStyle="overFullScreen"
					animationType="slide"
					swipeDirection="down"
					style={{ alignItems: 'center' }}>
					<TouchableOpacity
						style={{ width: 300, flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(255,255,255,0.5)', borderRadius: 10 }}
						activeOpacity={1}
						onPressOut={() => {
							this.setVisible(false);
						}}>
						{actions.map((v, i) => (
							<Button
								full
								style={[{ margin: 5, alignContent: 'center', borderRadius: 5 }, destructiveButtonIndex == i && { backgroundColor: '#9c3c3c' }]}
								key={i}
								onPress={() => {
									this.setVisible(false);
									onPress(v, i);
								}}>
								<Text style={{ color: 'white' }}>{v}</Text>
							</Button>
						))}
					</TouchableOpacity>
				</Modal>
			</View>
		);
	}
}
/*<Picker onValueChange={onPress} selectedValue={this.props.text} style={{ backgroundColor, borderColor, color, padding: 10, flex: 1, flexDirection: 'row' }}>
					{actions.map((val, idx) => (
						<Picker.Item label={val} value={idx} key={idx} style={{ color: '#555', backgroundColor: 'grey', paddingTop: 7, fontFamily: 'Roboto', fontSize: 20, paddingHorizontal: 15 }} />
					))}

					<Icon name="arrow-dropdown" style={{ color: '#BBB', paddingTop: 8, fontSize: 20 }} />
				</Picker>
PopupMenu.propTypes = {
  actions: React.PropTypes.array.isRequired,
  onPress: React.PropTypes.func.isRequired,
  children: React.PropTypes.object.isRequired,
};*/
